import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function UnreadMails() {
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://www.d-rosa.ai/gmail/unread")
      .then(res => res.json())
      .then(data => {
  if (data.success) {
    alert(
      `Total unread mails: ${data.count}\nAuto replied: ${data.replied}`
    );
  } else {
    alert("Failed to fetch unread mails");
  }

  navigate("/rosamkt");
})      .catch(err => {
        console.error(err);
        alert("Error while fetching unread mails");
        navigate("/rosamkt");
      });
  }, [navigate]);

  return (
    <div style={{ padding: 20 }}>
      <h2>Processing unread mails...</h2>
    </div>
  );
}

export default UnreadMails;
